import Sessions from './sessions'

const routes = [...Sessions]

export default routes
